import I18n from './I18n'

export class I18nUtils {

  static tr(value) {
    return I18n.t(value);
  }
}



// WEBPACK FOOTER //
// ./src/i18n/I18nUtils.js